"use strict";

angular.module('rmStationSettings')
    .service('datamodel', require('./datamodel_service'))
;